import {
  API_ENDPOINTS,
  apiRequest,
  BankValuationRequest,
  BankValuationRequestCreateDto,
  DataReturnType,
  HttpMethods,
} from "@alba-cars/common-modules";

import { convertDistance } from "@/lib/utils";
import { BankValuationCompleteFormSchemaType } from "@/schemas/validation/bankValuationSchema";

const calculateMileageInKms = (mileage: number, mileageUnit: "km" | "miles") => {
  if (mileageUnit === "km") {
    return mileage;
  }

  return convertDistance(mileage, { from: "miles", to: "km" });
};

export const createBankValuationRequest = async (data: BankValuationCompleteFormSchemaType) => {
  const { makeName, modelName, trimName, specification, currency: _c, ...restOfData } = data;

  const engineSize = data.engineSize ? Number(data.engineSize) : null;
  const mileageUnit = data.mileageUnit || "km";
  const mileage = data.mileage ? calculateMileageInKms(Number(data.mileage), mileageUnit) : 0;

  const payload: BankValuationRequestCreateDto = {
    ...restOfData,
    year: Number(data.year),
    make: makeName,
    makeDealDriveId: data.make,
    model: modelName,
    modelDealDriveId: data.model,
    dealDriveEstimatedPrice: Number(data.dealDriveEstimatedPrice ?? 0),
    mileage,
    engineSize,
    trimDealDriveId: restOfData.trim,
    trim: trimName,
    specification: specification,
    trimOption: data.trimOptionName,
    trimOptionDealDriveId: data.trimOption,
    clientMileage: data.clientMileage ? Number(data.clientMileage) : null,
    mileageUnit,
    engineNumber: data.engineNumber ?? "",
  };

  const response = await apiRequest<DataReturnType<BankValuationRequest>>(
    API_ENDPOINTS.bankValuationRequest.create.toString(),
    {
      method: HttpMethods.POST,
      body: JSON.stringify(payload),
    },
  );

  return response;
};
